import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.75 -0.75 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Currency Dollar Circle Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.125 7.969h-2.008a1.738 1.738 0 0 0-.777 3.292l1.828.915a1.738 1.738 0 0 1-.777 3.293H9.375M10.785 15.469v1.406M11.723 6.563v1.406"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.473 11.25a10.781 10.781 0 1 0 21.562 0 10.781 10.781 0 1 0-21.562 0"
    }, null, -1)
  ])))
}
export default { render: render }